import React from 'react';
import './WebsiteUnavailable.css';

const WebsiteUnavailable = () => {
  return (
    <div className="vacation-container">
      <div className="overlay"></div>

      <div className="content-card">
        <div className="brand-badge">
          Anoud Manor
        </div>

        <h1 className="title">Currently Unavailable</h1>
        
        <p className="description">
          Please check back soon to explore and book your next stay.
        </p>
      </div>
    </div>
  );
};

export default WebsiteUnavailable;